module.exports = __webpack_public_path__ + "media/images/brands/slack-b059fd0b91482a99d409be73b791122a.png";